function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m512 91.96v328.08c0 50.71-41.25 91.96-91.96 91.96h-328.08c-50.71 0-91.96-41.25-91.96-91.96v-328.08c0-50.71 41.25-91.96 91.96-91.96h328.08c50.71 0 91.96 41.25 91.96 91.96z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m512 91.96v328.08c0 50.71-41.25 91.96-91.96 91.96h-164.04v-512h164.04c50.71 0 91.96 41.25 91.96 91.96z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m432.69 399.56h-353.38c-19.92 0-19.93-30.12 0-30.12h353.38c19.92 0 19.93 30.12 0 30.12z",
  fill: "#55585e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m432.69 399.56h-176.69v-30.12h176.69c19.92 0 19.93 30.12 0 30.12z",
  fill: "#55585e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m431.18 269.55h-353.38c-19.92 0-19.92-30.11 0-30.11h353.38c19.93 0 19.93 30.11 0 30.11z",
  fill: "#55585e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m431.18 269.55h-175.18v-30.11h175.18c19.93 0 19.93 30.11 0 30.11z",
  fill: "#55585e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m431.18 141.05h-353.38c-19.92 0-19.92-30.12 0-30.12h353.38c19.93 0 19.93 30.12 0 30.12z",
  fill: "#55585e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m431.18 141.05h-175.18v-30.12h175.18c19.93 0 19.93 30.12 0 30.12z",
  fill: "#55585e"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 352.376,
  cy: 256,
  fill: "#e74b3c",
  r: 47.184
}), /*#__PURE__*/React.createElement("path", {
  d: "m399.561 256c0 26.022-21.163 47.184-47.184 47.184v-94.369c26.021.001 47.184 21.163 47.184 47.185z",
  fill: "#e74b3c"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 223.875,
  cy: 384.502,
  fill: "#607d8b",
  r: 47.184
}), /*#__PURE__*/React.createElement("path", {
  d: "m271.059 384.502c0 26.022-21.163 47.184-47.184 47.184v-94.369c26.021.001 47.184 21.163 47.184 47.185z",
  fill: "#607d8b"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159.624,
  cy: 127.498,
  fill: "#2c3e50",
  r: 47.184
}), /*#__PURE__*/React.createElement("path", {
  d: "m206.808 127.498c0 25.69-20.621 46.632-46.18 47.164v-94.328c25.559.532 46.18 21.474 46.18 47.164z",
  fill: "#2c3e50"
}));

var SvgOptionsIcon = function SvgOptionsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOptionsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/options-icon.ea4376cc.svg";
export { ForwardRef as ReactComponent };